interface AudienceToggleProps {
  audience: "brand" | "practitioner";
  onChange: (audience: "brand" | "practitioner") => void;
  brandLabel?: string;
  practitionerLabel?: string;
  hint?: string;
  sticky?: boolean;
}

const AudienceToggle = ({
  audience,
  onChange,
  brandLabel = "VDS Brands",
  practitionerLabel = "Practitioners",
  hint = "Explore for",
  sticky = true,
}: AudienceToggleProps) => {
  return (
    <div
      className={`${sticky ? "sticky top-14 sm:top-16 z-40" : ""} bg-background/95 backdrop-blur-sm border-b border-border`}
    >
      <div className="container max-w-5xl px-5 sm:px-6 lg:px-8 py-3 flex items-center justify-center gap-3">
        <span className="hidden sm:inline text-xs font-medium text-text-caption">{hint}</span>
        <div className="inline-flex bg-secondary rounded-full p-1 gap-1">



          <button
            onClick={() => onChange("brand")}
            className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
              audience === "brand"
                ? "bg-primary text-primary-foreground shadow-sm"
                : "text-text-body hover:text-foreground"
            }`}
          >
            {brandLabel}
          </button>
          <button
            onClick={() => onChange("practitioner")}
            className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
              audience === "practitioner"
                ? "bg-primary text-primary-foreground shadow-sm"
                : "text-text-body hover:text-foreground"
            }`}
          >
            {practitionerLabel}
          </button>

        </div>
      </div>
    </div>
  );
};

export default AudienceToggle;
